/**
 * 移除对象中所有值为 null 的属性
 * @param obj 要处理的对象
 * @returns 移除 null 值后的新对象
 */
export const removeNull = <T = any>(obj: T): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj
  }

  const result = { ...obj }

  for (const key in result) {
    if (result.hasOwnProperty(key)) {
      const value = result[key]
      
      if (value === null) {
        delete result[key]
      } else if (typeof value === 'object') {
        result[key] = removeNull(value)
      }
    }
  }

  return result
}

export default removeNull